import { render, staticRenderFns } from "./gaokTest.vue?vue&type=template&id=50da6037&scoped=true&"
import script from "./gaokTest.vue?vue&type=script&lang=js&"
export * from "./gaokTest.vue?vue&type=script&lang=js&"
import style0 from "./gaokTest.vue?vue&type=style&index=0&id=50da6037&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50da6037",
  null
  
)

export default component.exports